import { signal } from 'services/SignalsService'
import { animations, bonusMultiplierTime } from 'settings/custom/win'
import { delay } from 'utils/Delay'

const name = 'BONUS-MULTIPLIER'

export function getBonusMultiplierAction(skip) {

  function execute() {

    if (!animations.bonusMultiplier || skip) {
      return Promise.resolve()
    }

    signal.dispatch('BONUS-MULTIPLIER-ANIM')

    return delay(bonusMultiplierTime)
  }

  return {
    name,
    execute,
  }
}
